module.exports = __webpack_public_path__ + "img/tax1.4fae8ab0.png";